"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _tabbable = require("tabbable");
var _classnames4 = _interopRequireDefault(require("classnames"));
var _focusBoomerang = _interopRequireDefault(require("../../helpers/focus-boomerang"));
var _theme = require("../theme");
var _closeButton = _interopRequireDefault(require("./close-button"));
var _image = _interopRequireDefault(require("./image"));
var _sharedVariables = require("../../shared-variables");
require("./legacy-overlay.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Creates a fixed position overlay with entrance and exit animation. There are two variants:
 *
 * Image Overlay: uses a built in image slot, which renders visually like a dialog in desktop
 * viewports. The image layout is handled automatically. This version is triggered by providing
 * an `imagePath` in the props.
 *
 * Standard Overlay: When not using the imagePath prop, the overlay simply renders its children.
 * In mobile viewports, the Overlay covers the entire screen. In desktop viewports, there are
 * configuration options for which part of the viewport to cover. Overlay uses the FocusBoomerang utility to manage
 * focus correctly when opened and closed; consumers will need to take care of preventing focus to
 * content covered by the Overlay.
 *
 * If the consumer can place the Overlay in a spot in the DOM which permits the fixed positioning
 * to work correctly, the Overlay may be used as is. If there are positioning or layering issues
 * due to being nested in a positioned element, the consumer may choose to use the `Layer`
 * component to facilitate positioning correctly.
 *
 * To get exit animation, the content/children of Overlay should be removed before the Overlay itself.
 * If the Overlay is able to be mounted at all times, entrance and exit animations will always work.
 */
var Overlay = /*#__PURE__*/function (_Component) {
  function Overlay(props) {
    var _this;
    _classCallCheck(this, Overlay);
    _this = _callSuper(this, Overlay, [props]);
    _this.focusBoomerang = new _focusBoomerang["default"]();
    _this.containerRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _inherits(Overlay, _Component);
  return _createClass(Overlay, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      if (!this.props.focusOnOpen) {
        return;
      }
      // Set focus after brief delay to allow the component to render first.
      setTimeout(function () {
        var container = _this2.containerRef.current;
        if (!container) {
          return;
        }
        // Elements that can only be set focus programmatically
        var firstFocusable = container.querySelectorAll('[tabIndex="-1"]')[0];
        var tabbableElements = (0, _tabbable.tabbable)(container);
        var firstTabbable = tabbableElements[0];
        if ((0, _get2["default"])(firstTabbable, 'dataset.isCloseButton', false) && tabbableElements.length > 1) {
          firstTabbable = tabbableElements[1];
        }
        _this2.focusBoomerang.check({
          wasActive: Boolean(prevProps.children),
          isActive: Boolean(_this2.props.children),
          // Set focus to the most appropriate item
          focusedWhenActive: firstFocusable || firstTabbable || container
        });
      }, 150);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      // eslint-disable-next-line no-console
      console.warn('Deprecation notice: This legacy version of the Overlay will be removed in an upcoming major version. Please update all Overlay usage to work with ModalProvider.');
      var _this$props = this.props,
        alignment = _this$props.alignment,
        children = _this$props.children,
        childrenContainerClassName = _this$props.childrenContainerClassName,
        className = _this$props.className,
        closeCallback = _this$props.closeCallback,
        closeProps = _this$props.closeProps,
        containerProps = _this$props.containerProps,
        imageAlt = _this$props.imageAlt,
        imageContainerProps = _this$props.imageContainerProps,
        imagePath = _this$props.imagePath,
        permitImageToShrink = _this$props.permitImageToShrink,
        imageObjectFit = _this$props.imageObjectFit,
        renderCloseButton = _this$props.renderCloseButton,
        showMask = _this$props.showMask,
        style = _this$props.style,
        topShadow = _this$props.topShadow;
      var isImageVariant = Boolean(imagePath);
      var maskClasses = 'sb-overlay__mask size12of12 height-100 bg-houseGreen visible';
      return /*#__PURE__*/_react["default"].createElement(_theme.ThemeContext.Consumer, null, function (theme) {
        var themeClass = theme === _theme.themes.dark ? 'bg-houseGreen color-textWhite' : 'bg-white';
        var containerClasses = (0, _classnames4["default"])('visible', _defineProperty(_defineProperty({
          'sb-imageOverlay__container': isImageVariant,
          'sb-overlay__container': !isImageVariant,
          'sb-overlay--leftCrate': !isImageVariant && alignment === 'leftCrate',
          'sb-overlay--rightCrate': !isImageVariant && alignment === 'rightCrate',
          'sb-overlay--leftThird': !isImageVariant && alignment === 'leftThird',
          'sb-overlay--rightThird': !isImageVariant && alignment === 'rightThird',
          'sb-overlay--topShadow': topShadow
        }, themeClass, !isImageVariant), className, Boolean(className)));
        var contentClasses = (0, _classnames4["default"])('flex flex-column', _defineProperty(_defineProperty({
          'sb-overlay--heightLimit': permitImageToShrink,
          'sb-imageOverlay__content': isImageVariant
        }, themeClass, isImageVariant), 'sb-overlay__content', !isImageVariant));
        return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.TransitionGroup, {
          appear: true,
          component: null
        }, children ? /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
          classNames: "sb-overlay",
          timeout: {
            enter: parseInt(_sharedVariables.variables.defaultAnimationEntranceDuration, 10),
            exit: parseInt(_sharedVariables.variables.defaultAnimationExitDuration, 10)
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "sb-overlay__wrapper invisible",
          style: style
        }, showMask && /*#__PURE__*/_react["default"].createElement("div", {
          className: maskClasses,
          onClick: closeCallback
        }), /*#__PURE__*/_react["default"].createElement("div", _extends({
          className: containerClasses,
          key: "container",
          ref: _this3.containerRef,
          tabIndex: "-1"
        }, containerProps), /*#__PURE__*/_react["default"].createElement("div", {
          className: contentClasses,
          key: "content",
          style: permitImageToShrink ? {
            maxHeight: 'fit-content'
          } : {}
        }, renderCloseButton && /*#__PURE__*/_react["default"].createElement(_closeButton["default"], {
          closeCallback: closeCallback,
          closeProps: closeProps,
          isImageVariant: isImageVariant
        }), isImageVariant && /*#__PURE__*/_react["default"].createElement(_image["default"], {
          alt: imageAlt,
          containerProps: imageContainerProps,
          objectFit: imageObjectFit,
          permitToShrink: permitImageToShrink,
          src: imagePath
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames4["default"])('flex-grow', _defineProperty({
            'flex-shrink-none': permitImageToShrink
          }, childrenContainerClassName, Boolean(childrenContainerClassName)))
        }, children))))) : null);
      });
    }
  }]);
}(_react.Component);
Overlay.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Indicates what portion of the UI is covered in desktop viewports. Only applicable
   * when not using the imagePath option.
   */
  alignment: _propTypes["default"].oneOf(['fullscreen', 'rightCrate', 'leftCrate', 'rightThird', 'leftThird']).isRequired,
  /**
   * Nested component(s) which become the content of the overlay.
   */
  children: _propTypes["default"].any,
  /**
   * Classname passed to the element that wraps the children
   */
  childrenContainerClassName: _propTypes["default"].string,
  /**
   * Function attached to the click event of the included close button.
   */
  closeCallback: _propTypes["default"].func,
  /**
   * Props passed to the CloseButton component within the Overlay.
   */
  closeProps: _propTypes["default"].object,
  /**
   * Additional props to be spread on the container HTMLElement.
   */
  containerProps: _propTypes["default"].object,
  /**
   * When true, focus will be placed on the container div of the overlay when opened, permitting
   * seamless keyboard traversal. When false, the consumer is expected to manage focus.
   */
  focusOnOpen: _propTypes["default"].bool.isRequired,
  /**
   * Prop to allow for giving alternate text to the image
   */
  imageAlt: _propTypes["default"].string,
  /**
   * Props to pass into the container around the image
   */
  imageContainerProps: _propTypes["default"].object,
  /**
   * Optional prop to allow for image to be placed on top of the Overlay.
   */
  imagePath: _propTypes["default"].string,
  /**
   * Optional prop to allow for a top-image to be responsive. This is useful when you have tall content and a scalable image. Only applicable if imagePath is passed.
   */
  permitImageToShrink: _propTypes["default"].bool,
  /**
   * Optional prop to control the object-fit of the top image. Only applicable if imagePath is passed and permitImageToShrink is true.
   */
  imageObjectFit: _propTypes["default"].oneOf(['cover', 'contain', 'fill', 'scale-down']),
  /**
   * Whether to use the included default CloseButton component. If false, consumer is expected to
   * provide a custom close button in the children.
   */
  renderCloseButton: _propTypes["default"].bool.isRequired,
  /**
   * Whether to show a mask when the overlay is opened.
   */
  showMask: _propTypes["default"].bool,
  /**
   * Optional style object for custom styling such as z-index; applied to the outermost div.
   */
  style: _propTypes["default"].object,
  /**
   * A CSS box shadow intended for situations in which another container is visually 'above' the
   * overlay.
   */
  topShadow: _propTypes["default"].bool.isRequired
} : {};
Overlay.defaultProps = {
  alignment: 'rightCrate',
  closeCallback: function closeCallback() {},
  closeProps: {},
  focusOnOpen: true,
  imageAlt: ' ',
  imageObjectFit: 'cover',
  renderCloseButton: true,
  showMask: true,
  topShadow: false
};
var _default = exports["default"] = Overlay;